import { render, staticRenderFns } from "./EmergencyContactForm.vue?vue&type=template&id=22ee0965"
import script from "./EmergencyContactForm.vue?vue&type=script&lang=js"
export * from "./EmergencyContactForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports